import {Example} from "./Example";
import {useTranslation} from "react-i18next";

import styles from "./Example.module.css";

interface Props {
    onExampleClicked: (value: string) => void;
    useGPT4V?: boolean;
}

export const ExampleList = ({onExampleClicked, useGPT4V}: Props) => {
    const {t} = useTranslation();

    const DEFAULT_EXAMPLES: string[] = [
        t("defaultExamples.1"), t("defaultExamples.2"), t("defaultExamples.3"),
        t("defaultExamples.4"), t("defaultExamples.5"), t("defaultExamples.6"),
    ];
    const GPT4V_EXAMPLES: string[] = [t("gpt4vExamples.1"), t("gpt4vExamples.2"), t("gpt4vExamples.3")];

    return (
        <ul className={"grid grid-cols-1 gap-4 md:grid-cols-3 auto-rows-fr px-1"}>
            {(useGPT4V ? GPT4V_EXAMPLES : DEFAULT_EXAMPLES).map((question, i) => (
                <li key={i} className="h-full">
                    <Example text={question} value={question} onClick={onExampleClicked}/>
                </li>
            ))}
        </ul>
    );
};
